module.exports = __webpack_public_path__ + "static/cpas-4e6fd3313c02c75a5dd61292591149f2.png";